module.exports = require('../package.json').version;



/*****************
 ** WEBPACK FOOTER
 ** ./~/websocket/lib/version.js
 ** module id = 4172
 ** module chunks = 0
 **/